module.exports = __webpack_public_path__ + "img/qrcode2.37750746.jpg";